import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import DashboardGamesTable from '../components/DashboardGamesTable';
import DashboardGamesUploadDialog from '../components/DashboardGamesUploadDialog';
import { useDashboardGamesPageLogic } from '../hooks/useDashboardGamesPageLogic';
import {
  adminButtonSx,
  adminButtonToneSx,
  adminCombineSx,
  adminPageHeaderSx,
} from '../../../../styles/adminComponentStyles';

const DashboardGamesPage: React.FC = () => {
  const {
    stateSearchTerm,
    csvDialogOpen,
    selectedCsvFile,
    showAllRegions,
    statesLoading,
    statesError,
    savingStateCode,
    filteredStatesTableRows,
    handleStateChange,
    handleSearchChange,
    handleCsvDialogOpen,
    handleCsvDialogClose,
    handleCsvFileChange,
    handleRemoveCsvFile,
    handleShowAllRegionsChange,
    handleCsvUpload,
    handleProviderSave,
  } = useDashboardGamesPageLogic();

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Box sx={adminPageHeaderSx}>
          <Typography className="AdminPageHeader-title">
            All Locations
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
            <Button
              variant="contained"
              disabled
              onClick={handleCsvDialogOpen}
              startIcon={<Icon icon="material-symbols:cloud-upload" width="18" height="18" />}
              size="small"
              sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary, { minWidth: 128 })}
            >
              Upload CSV
            </Button>
          </Stack>
        </Box>

        <DashboardGamesTable
          rows={filteredStatesTableRows}
          search={stateSearchTerm}
          loading={statesLoading}
          error={statesError}
          showAllRegions={showAllRegions}
          onShowAllRegionsChange={handleShowAllRegionsChange}
          onSearchChange={handleSearchChange}
          onStateOpen={handleStateChange}
          savingStateCode={savingStateCode}
          onProviderSave={handleProviderSave}
        />
      </Box>

      <DashboardGamesUploadDialog
        open={csvDialogOpen}
        selectedCsvFile={selectedCsvFile}
        onClose={handleCsvDialogClose}
        onFileChange={handleCsvFileChange}
        onRemoveFile={handleRemoveCsvFile}
        onUpload={handleCsvUpload}
      />
    </Box>
  );
};

export default DashboardGamesPage;
